import { faAlignLeft, faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { FC } from 'react';
import { cn } from '../../utils/util';
import Badge from './Badge';
import PrimaryButton from './PrimaryButton';
import { translate } from '../../utils/language';
import { plans } from '../../data/plans_dummy';
// USD | EUR | GBP | TRY
type Currency = '$' | '€' | '£' | '₺';

type Prices = {
  oldPrice?: number | null;
  newPrice: number;
  currencySymbol: Currency;
  currency: string,
  monthlyPrice: string
};

interface PricingCardProps {
  title: string;
  prices: Prices;
  description: string;
  features: string[];
  yearly?: boolean;
  highlighted?: boolean;
  selected?: boolean;
  setSelected?: () => void;
  isPopular?: boolean;
  isPremium?: boolean;
  isDisabled?: boolean
}

const DefaultPrices: Prices = {
  oldPrice: 0,
  newPrice: 0,
  currency: 'TRY',
  currencySymbol: '₺',
  monthlyPrice: "0"
};

const PricingCard: FC<PricingCardProps> = ({
  title,
  description,
  prices = DefaultPrices,
  features,
  selected,
  setSelected,
  isPremium,
  isPopular,
  isDisabled
}) => {

  console.log(prices)
  return (
    <>
      {!isPremium ? (
        <div
          onClick={(e) => { !isDisabled && setSelected?.() }}
          className={cn(
            'w-full lg:w-[360px] p-[30px] bg-white flex flex-col rounded-[15px] border duration-300 h-full gap-[10px] min-h-[460px] border-[2px] hover:border-[#7059ef80] cursor-pointer',
            selected && ' border-[#7059EF] ',
            isDisabled && ' opacity-40 select-none cursor-not-allowed'
          )}
        >
          <div>
            <div className="flex align-center ">
              <h3 className="text-[20px] font-semibold	 text-[#000000] leading-[29.05px]">{title}</h3>
              {isPopular && (
                <div className="flex items-center gap-[5px] py-[5px] px-[7px] border border-[#FFB0B1] rounded-[10px] bg-[#fff2f2] ml-[12px]">
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
                    <path
                      d="M5.93346 1.36507C6.14982 0.878311 6.85142 0.878311 7.06716 1.36507L8.15017 3.81224C8.19507 3.91348 8.26712 4.00078 8.3586 4.06477C8.45008 4.12876 8.55753 4.16704 8.66943 4.17549L11.4283 4.38357C11.9846 4.42556 12.2041 5.11371 11.772 5.46113L9.71349 7.11794C9.62283 7.19096 9.55511 7.28784 9.51822 7.39728C9.48134 7.50673 9.47682 7.62424 9.50517 7.73612L10.1419 10.2423C10.2742 10.7644 9.70299 11.1866 9.23071 10.9153L6.81186 9.52739C6.71731 9.47308 6.60979 9.44446 6.50031 9.44446C6.39083 9.44446 6.28332 9.47308 6.18876 9.52739L3.76991 10.9153C3.29764 11.1866 2.72646 10.7644 2.85874 10.2423L3.49545 7.73612C3.52354 7.62421 3.51876 7.50675 3.48166 7.39742C3.44456 7.28809 3.37667 7.19137 3.28589 7.11855L1.22743 5.46174C0.795953 5.11432 1.01602 4.42617 1.57174 4.38418L4.32996 4.17609C4.44186 4.16765 4.54931 4.12937 4.64078 4.06538C4.73226 4.00139 4.80431 3.91409 4.84921 3.81285L5.93346 1.36507Z"
                      stroke="#EC4E50"
                    />
                  </svg>
                  <div className="text-[#EC4E50] text-[10px] font-semibold">En Popüler</div>
                </div>
              )}
            </div>
            <div className="flex gap-[10px] mt-[10px] align-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                <path
                  d="M10.77 9C10.83 8.505 10.875 8.01 10.875 7.5C10.875 6.99 10.83 6.495 10.77 6H13.305C13.425 6.48 13.5 6.9825 13.5 7.5C13.5 8.0175 13.425 8.52 13.305 9M9.4425 13.17C9.8925 12.3375 10.2375 11.4375 10.4775 10.5H12.69C11.9634 11.7512 10.8106 12.699 9.4425 13.17ZM9.255 9H5.745C5.67 8.505 5.625 8.01 5.625 7.5C5.625 6.99 5.67 6.4875 5.745 6H9.255C9.3225 6.4875 9.375 6.99 9.375 7.5C9.375 8.01 9.3225 8.505 9.255 9ZM7.5 13.47C6.8775 12.57 6.375 11.5725 6.0675 10.5H8.9325C8.625 11.5725 8.1225 12.57 7.5 13.47ZM4.5 4.5H2.31C3.02898 3.24528 4.18099 2.29593 5.55 1.83C5.1 2.6625 4.7625 3.5625 4.5 4.5ZM2.31 10.5H4.5C4.7625 11.4375 5.1 12.3375 5.55 13.17C4.1837 12.6992 3.03322 11.7511 2.31 10.5ZM1.695 9C1.575 8.52 1.5 8.0175 1.5 7.5C1.5 6.9825 1.575 6.48 1.695 6H4.23C4.17 6.495 4.125 6.99 4.125 7.5C4.125 8.01 4.17 8.505 4.23 9M7.5 1.5225C8.1225 2.4225 8.625 3.4275 8.9325 4.5H6.0675C6.375 3.4275 6.8775 2.4225 7.5 1.5225ZM12.69 4.5H10.4775C10.2424 3.57121 9.89484 2.67458 9.4425 1.83C10.8225 2.3025 11.97 3.255 12.69 4.5ZM7.5 0C3.3525 0 0 3.375 0 7.5C0 9.48912 0.790176 11.3968 2.1967 12.8033C2.89314 13.4997 3.71993 14.0522 4.62987 14.4291C5.53982 14.806 6.51509 15 7.5 15C9.48912 15 11.3968 14.2098 12.8033 12.8033C14.2098 11.3968 15 9.48912 15 7.5C15 6.51509 14.806 5.53982 14.4291 4.62987C14.0522 3.71993 13.4997 2.89314 12.8033 2.1967C12.1069 1.50026 11.2801 0.947814 10.3701 0.570904C9.46018 0.193993 8.48491 0 7.5 0Z"
                  fill="#495567"
                />
              </svg>
              <p className="text-[15px] text-[#495567] leading-[16.94px] font-semibold	"> {description}</p>
            </div>
          </div>
          <div className="mt-[10px] mb-[10px] border border-[#C5C5C5]" />

          <div className="flex h-[40px]  flex-col justify-center">
            <div className="flex flex-row items-center">
              <h3 className="text-[30px] text-[#1e1e1e] font-[800] leading-[35.15px]">
                {prices.currencySymbol}
                {prices.monthlyPrice === "0" ? translate('Free') : prices.monthlyPrice?.toLocaleString() + ' '}
              </h3>
              {prices.newPrice === 0 ? (
                ''
              ) : (
                <div className="h-full text-[14px] text-[#667588] leading-[18.15px] font-semibold pt-[5px] pl-[3px]">
                  /Aylık
                </div>
              )}
            </div>
            <div className='text-gray-500 font-semibold text-[12px]'>
              Yıllık {prices.currencySymbol} {prices.newPrice.toLocaleString()} <span className='text-[10px]'>(KDV Dahil)</span>
            </div>
          </div>

          <button
            style={{
              marginTop: '10px',
              paddingTop: '10px',
              paddingBottom: '10px',
              fontSize: '14px',
              fontWeight: 600,
              borderWidth: '1px',
              borderRadius: '10px',
              borderColor: '#7454FF',
              color: '#7454FF',
              backgroundColor: '#FFFFFF',
              cursor: isDisabled ? "not-allowed" : "cursor"
            }}

          >
            Planı Seç
          </button>
          <div className="mt-[10px] mb-[10px] border border-[#C5C5C5]" />
          <div className="flex flex-col  gap-3">
            <p className="text-[12px] text-[#000000] font-semibold leading-[16.94px]">Diğer Özellikler;</p>
            {features.map((feature, index) => (
              <div className="flex items-center gap-[10px] " key={feature + index}>
                <div className="  flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10" fill="none">
                    <path
                      d="M13 1.05145L4.08571 10L0 5.89858L1.04743 4.84713L4.08571 7.88963L11.9526 0L13 1.05145Z"
                      fill="#6F66F6"
                    />
                  </svg>
                </div>
                <span className="text-[12px] text-[#0F1927] font-semibold leading-[16.94px]">{feature}</span>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div
          className={cn(
            'w-full lg:w-[360px] p-[30px] bg-[#6F66F6] flex flex-col rounded-[15px] border-4 border duration-500 h-full gap-[10px] min-h-[460px]',
            selected && ' border-[#7059EF]',
            isDisabled && ' opacity-40 select-none cursor-not-allowed'

          )}
          onClick={(e) => { !isDisabled && setSelected?.() }}
        >
          <div>
            <h3 className="text-[20px] font-semibold text-[#FFFFFF]	 leading-[29.05px]">{title}</h3>
            <div className="flex gap-[10px] mt-[10px] align-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                <path
                  d="M10.77 9C10.83 8.505 10.875 8.01 10.875 7.5C10.875 6.99 10.83 6.495 10.77 6H13.305C13.425 6.48 13.5 6.9825 13.5 7.5C13.5 8.0175 13.425 8.52 13.305 9M9.4425 13.17C9.8925 12.3375 10.2375 11.4375 10.4775 10.5H12.69C11.9634 11.7512 10.8106 12.699 9.4425 13.17ZM9.255 9H5.745C5.67 8.505 5.625 8.01 5.625 7.5C5.625 6.99 5.67 6.4875 5.745 6H9.255C9.3225 6.4875 9.375 6.99 9.375 7.5C9.375 8.01 9.3225 8.505 9.255 9ZM7.5 13.47C6.8775 12.57 6.375 11.5725 6.0675 10.5H8.9325C8.625 11.5725 8.1225 12.57 7.5 13.47ZM4.5 4.5H2.31C3.02898 3.24528 4.18099 2.29593 5.55 1.83C5.1 2.6625 4.7625 3.5625 4.5 4.5ZM2.31 10.5H4.5C4.7625 11.4375 5.1 12.3375 5.55 13.17C4.1837 12.6992 3.03322 11.7511 2.31 10.5ZM1.695 9C1.575 8.52 1.5 8.0175 1.5 7.5C1.5 6.9825 1.575 6.48 1.695 6H4.23C4.17 6.495 4.125 6.99 4.125 7.5C4.125 8.01 4.17 8.505 4.23 9M7.5 1.5225C8.1225 2.4225 8.625 3.4275 8.9325 4.5H6.0675C6.375 3.4275 6.8775 2.4225 7.5 1.5225ZM12.69 4.5H10.4775C10.2424 3.57121 9.89484 2.67458 9.4425 1.83C10.8225 2.3025 11.97 3.255 12.69 4.5ZM7.5 0C3.3525 0 0 3.375 0 7.5C0 9.48912 0.790176 11.3968 2.1967 12.8033C2.89314 13.4997 3.71993 14.0522 4.62987 14.4291C5.53982 14.806 6.51509 15 7.5 15C9.48912 15 11.3968 14.2098 12.8033 12.8033C14.2098 11.3968 15 9.48912 15 7.5C15 6.51509 14.806 5.53982 14.4291 4.62987C14.0522 3.71993 13.4997 2.89314 12.8033 2.1967C12.1069 1.50026 11.2801 0.947814 10.3701 0.570904C9.46018 0.193993 8.48491 0 7.5 0Z"
                  fill="#FFFFFF"
                />
              </svg>
              <p className="text-[15px] text-[#FFFFFF] leading-[16.94px] font-semibold	"> {description}</p>
            </div>
          </div>
          <div className="mt-[10px] mb-[10px] border border-[#C5C5C5]" />

          {/* {discount && prices.oldPrice && (
    <div className="flex items-center justify-start gap-[10px] mt-[25px] mb-5">
      <p className="text-[#8A92A6] font-medium leading-[19.36px] line-through">
        {prices.currency}
        {(prices.oldPrice * (yearly ? 10 : 1)).toFixed(3)}
      </p>

      <Badge label={`%${discount} indirim`}>
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
          <path
            d="M14.6438 6.65874L13.5038 5.51703C13.3088 5.32173 13.1513 4.93866 13.1513 4.66825V3.04582C13.1513 2.38483 12.6112 1.84402 11.9513 1.84402H10.3387C10.0687 1.84402 9.68625 1.68628 9.49125 1.49099L8.35125 0.349274C7.88625 -0.116425 7.12125 -0.116425 6.65625 0.349274L5.50125 1.49099C5.31375 1.68628 4.93125 1.84402 4.65375 1.84402H3.04125C2.38125 1.84402 1.84125 2.38483 1.84125 3.04582V4.66074C1.84125 4.93115 1.68375 5.31422 1.48875 5.50951L0.34875 6.65123C-0.11625 7.11693 -0.11625 7.88307 0.34875 8.34877L1.48875 9.49049C1.68375 9.68578 1.84125 10.0689 1.84125 10.3393V11.9542C1.84125 12.6152 2.38125 13.156 3.04125 13.156H4.65375C4.92375 13.156 5.30625 13.3137 5.50125 13.509L6.64125 14.6507C7.10625 15.1164 7.87125 15.1164 8.33625 14.6507L9.47625 13.509C9.67125 13.3137 10.0538 13.156 10.3238 13.156H11.9362C12.5962 13.156 13.1363 12.6152 13.1363 11.9542V10.3393C13.1363 10.0689 13.2938 9.68578 13.4888 9.49049L14.6288 8.34877C15.1163 7.89059 15.1163 7.12444 14.6438 6.65874ZM4.49625 5.25413C4.49625 4.84101 4.83375 4.503 5.24625 4.503C5.65875 4.503 5.99625 4.84101 5.99625 5.25413C5.99625 5.66725 5.66625 6.00526 5.24625 6.00526C4.83375 6.00526 4.49625 5.66725 4.49625 5.25413ZM5.64375 10.159C5.53125 10.2717 5.38875 10.3242 5.24625 10.3242C5.10375 10.3242 4.96125 10.2717 4.84875 10.159C4.63125 9.94116 4.63125 9.58062 4.84875 9.36279L9.34875 4.85603C9.56625 4.63821 9.92625 4.63821 10.1437 4.85603C10.3612 5.07386 10.3612 5.4344 10.1437 5.65223L5.64375 10.159ZM9.74625 10.512C9.32625 10.512 8.98875 10.174 8.98875 9.76089C8.98875 9.34777 9.32625 9.00976 9.73875 9.00976C10.1512 9.00976 10.4887 9.34777 10.4887 9.76089C10.4887 10.174 10.1587 10.512 9.74625 10.512Z"
            fill="#24A8AF"
          />
        </svg>
      </Badge>
    </div>
  )} */}

          <div className="flex h-[40px] flex-col justify-center">
            <div className="text-[14px] font-semibold	 text-[#FFFFFF] leading-[16.94px] text-center ">
              Fiyat Teklifi Almak İçin İletişime Geçin
            </div>
          </div>
          <button
            style={{
              marginTop: '10px',
              paddingTop: '10px',
              paddingBottom: '10px',
              fontSize: '14px',
              fontWeight: 600,
              borderWidth: '1px',
              borderRadius: '10px',
              borderColor: '#7454FF',
              color: '#7454FF',
              backgroundColor: '#FFFFFF',
            }}
          >
            Bize Ulaşın
          </button>
          <div className="mt-[10px] mb-[10px] border border-[#C5C5C5]" />
          <div className="flex flex-col  gap-3">
            <p className="text-[12px] text-[#FFFFFF] font-semibold leading-[16.94px]">Diğer Özellikler;</p>
            {features.map((feature, index) => (
              <div className="flex items-center gap-[10px] " key={feature + index}>
                <div className="  flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10" fill="none">
                    <path
                      d="M13 1.05145L4.08571 10L0 5.89858L1.04743 4.84713L4.08571 7.88963L11.9526 0L13 1.05145Z"
                      fill="#FFFFFF"
                    />
                  </svg>
                </div>
                <span className="text-[12px] text-[#FFFFFF] font-semibold leading-[16.94px]">{feature}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};
export default PricingCard;
